export enum AuditRequestType {
    GATEWAY = "GATEWAY",
    APPLICATION = "APPLICATION"
}